import httpClient from "./httpClient";

const DashboardService = {
  async getStats() {
    return await httpClient.get("/dashboard/stats");
  },

  async getConnectivity() {
    return await httpClient.get("/dashboard/connectivity");
  }
};

export default DashboardService;
